import React from 'react'

export interface PlayerAvatarProps {
  /** Nome do atleta */
  name: string
  /** URL da imagem do atleta */
  imageUrl?: string | null
}

const PlayerAvatar: React.FC<PlayerAvatarProps> = ({ name, imageUrl }) => {
  const src = imageUrl || '/assets/images/user.png'
  return (
    <div className="d-flex flex-column align-items-center" style={{ width: 80 }}>
      <img
        src={src}
        alt={name}
        className="rounded-circle"
        style={{ width: 64, height: 64, objectFit: 'cover' }}
      />
      <span className="mt-1 text-center" style={{ fontSize: 12 }}>
        {name}
      </span>
    </div>
  )
}

export default PlayerAvatar
